import React, { Component } from 'react'
class RequirePopup extends Component {
  regEx = {
    // eslint-disable-next-line
    email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  }
  state= {val: "",isValid: '',isAccept: false}
  onEmailChange = e => {
    const isValid =this.regEx.email.test(String(e.target.value).toLowerCase())?'is-valid':'is-invalid';
    this.setState({val:e.target.value,isValid})
  }
  onAgreementChange = e => {
    this.setState({isAccept:!this.state.isAccept})
  }
  onConfirm = e => {
    const { require, perpose,onClose} = this.props;
    const { val,isValid,isAccept} = this.state
    if(isValid==='is-valid'&&isAccept){
      onClose({[require]:val,perpose})
    }else{
      if(isValid !== 'is-valid')
        this.setState({isValid: 'is-invalid'})
      if(!isAccept){
        this.setState({isValid: 'is-not-accept'})
      }
    }
  }
  render() {
    const {  message,onClose} = this.props;
    const { val,isValid,isAccept} = this.state
    return (
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button type="button" className="close" onClick={()=>onClose(false)} data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{message}</p>
              <div className="form-group mt-3">
                <input type="email" value={val} onChange={this.onEmailChange} placeholder="Email" required className={`form-control ${isValid}`} />
                <div className="invalid-feedback text-center">{isValid === 'is-invalid'?`Please enter a valid email!`:null}</div>
              </div>
              <div className="from-group d-flex align-items-center mt-3">
                  <div className="material-switch pull-right mr-2">
                      <input  id="accept_agreement" checked={isAccept} onChange={this.onAgreementChange} name="accept_agreement" type="checkbox"/>
                      <label htmlFor="accept_agreement" className="label-success"></label>
                  </div>
                  Accept agreement
              </div>
              <div className={`invalid-feedback ${isValid}`}>{isValid === 'is-not-accept'?`Please accept the agreement!`:null}</div>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={()=>onClose(false)}  className="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" onClick={this.onConfirm} className="btn btn-primary">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RequirePopup;